var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"pdf2html"}},[(_vm.fileInfo)?_c('PdfView',{attrs:{"directoryShow":false,"htmlJSON":_vm.htmlJSON,"tableJSON":_vm.tableJSON,"filePath":_vm.fileInfo.file_path + '?report_id=' + _vm.$route.query.id,"baseUrl":_vm.fileInfo.json_path + '/images/',"showConfig":{
      directoryShow: false,
      tableType: 'copy',
      imageShow: true,
    }},on:{"pdfRendered":_vm.pdfRendered,"pdfPageRender":_vm.pdfPageRender,"changeZoom":_vm.changeZoom}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }